import { Builder } from "@builder.io/react";
import { allowedFileTypes, commonInputs, registerMenuGroups } from "./helper";
import { FormSection, FormSelector, InvoiceFinanceEnquireForm, TradeFinanceEnquireForm, OctetPayEnquireForm, TermLoanEnquireForm, BuyerProtectionEnquireForm, Points4PayEnquireForm, McDonaldsProgramForm, ContactSupportForm, CPAEventForm, PartnerProgramForm, CountryWideForm, KfcProgramForm, CpaProgramForm } from "@/components/Form";

const formComponents = [ 
  {
    name: "Form",
    items: [  
      { name: "FormSection" },
      { name: "FormSelector" },
      { name: "InvoiceFinanceEnquireForm" },
      { name: "TradeFinanceEnquireForm" },
      { name: "OctetPayEnquireForm" },
      { name: "TermLoanEnquireForm" },
      { name: "BuyerProtectionEnquireForm" },
      { name: "Points4PayEnquireForm" },
      { name: "McDonaldsProgramForm" },
      { name: "KfcProgramForm" },
      { name: "CpaProgramForm" },
      { name: "ContactSupportForm" },
      { name: "CPAEventForm" },
      { name: "PartnerProgramForm" },
      { name: "CountryWideForm" }

    ]
  },
];



export const registerFormComponents = () => {
  registerMenuGroups(formComponents);

  Builder.registerComponent(FormSection, {
    name: 'FormSection',
    noWrap: true,
    inputs: [
      {
        name: "combinedLogo",
        type: "file",
        allowedFileTypes: allowedFileTypes,
      },
      {
        name: "headerBackgroundColour",
        type: "color",
      },
      {
        name: "withRightColumn",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "leftColumn",
        type: 'uiBlocks',
        defaultValue: [],
      },
      {
        name: "rightColumn",
        type: 'uiBlocks',
        showIf: `options.get('withRightColumn') === true`,
        defaultValue: [],
      },
    ],
  });

  Builder.registerComponent(FormSelector, {
    name: 'FormSelector',
    noWrap: true,
    inputs: [
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "form",
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: 'text',
          },
          {
            name: 'subtitle',
            type: 'longText',
          },
          { 
            name: 'link',
            type: 'url',
          },
        ],
      },
      {
        name: "helperText",
        type: 'richText',
      },  
      {
        name: "infoBoxText",
        type: 'richText',
      }
    ],
  });

  Builder.registerComponent(InvoiceFinanceEnquireForm, {
    name: 'InvoiceFinanceEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(TradeFinanceEnquireForm, {
    name: 'TradeFinanceEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(OctetPayEnquireForm, {
    name: 'OctetPayEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(TermLoanEnquireForm, {
    name: 'TermLoanEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(BuyerProtectionEnquireForm, {
    name: 'BuyerProtectionEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(Points4PayEnquireForm, {
    name: 'Points4PayEnquireForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(McDonaldsProgramForm, {
    name: 'McDonaldsProgramForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(ContactSupportForm, {
    name: 'ContactSupportForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(CPAEventForm, {
    name: 'CPAEventForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(PartnerProgramForm, {
    name: 'PartnerProgramForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(CountryWideForm, {
    name: 'CountryWideForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(KfcProgramForm, {
    name: 'KfcProgramForm',
    noWrap: true,
    inputs: [],
  });

  Builder.registerComponent(CpaProgramForm, {
    name: 'CpaProgramForm',
    noWrap: true,
    inputs: [],
  });
};

